export const countries = [
  {
    code: "CN",
    zh: "中国",
    en: "China",
    countryCode: "+86",
  },
  {
    code: "HK",
    zh: "中国香港",
    en: "Hong Kong",
    countryCode: "+852",
  },
  {
    code: "TW",
    zh: "中国台湾",
    en: "Taiwan",
    countryCode: "+886",
  },
  {
    code: "MO",
    zh: "中国澳门",
    en: "Macao",
    countryCode: "+853",
  },
  {
    code: "JP",
    zh: "日本",
    en: "Japan",
    countryCode: "+81",
  },
  {
    code: "KR",
    zh: "韩国",
    en: "South Korea",
    countryCode: "+82",
  },
  {
    code: "US",
    zh: "美国",
    en: "United States",
    countryCode: "+1",
  },
  {
    code: "GB",
    zh: "英国",
    en: "United Kingdom",
    countryCode: "+44",
  },
  {
    code: "FR",
    zh: "法国",
    en: "France",
    countryCode: "+33",
  },
  {
    code: "DE",
    zh: "德国",
    en: "Germany",
    countryCode: "+49",
  },
  {
    code: "IT",
    zh: "意大利",
    en: "Italy",
    countryCode: "+39",
  },
  {
    code: "ES",
    zh: "西班牙",
    en: "Spain",
    countryCode: "+34",
  },
  {
    code: "AU",
    zh: "澳大利亚",
    en: "Australia",
    countryCode: "+61",
  },
  {
    code: "NZ",
    zh: "新西兰",
    en: "New Zealand",
    countryCode: "+64",
  },
  {
    code: "SG",
    zh: "新加坡",
    en: "Singapore",
    countryCode: "+65",
  },
  {
    code: "MY",
    zh: "马来西亚",
    en: "Malaysia",
    countryCode: "+60",
  },
  {
    code: "TH",
    zh: "泰国",
    en: "Thailand",
    countryCode: "+66",
  },
  {
    code: "VN",
    zh: "越南",
    en: "Vietnam",
    countryCode: "+84",
  },
  {
    code: "ID",
    zh: "印度尼西亚",
    en: "Indonesia",
    countryCode: "+62",
  },
  {
    code: "PH",
    zh: "菲律宾",
    en: "Philippines",
    countryCode: "+63",
  },
  {
    code: "IN",
    zh: "印度",
    en: "India",
    countryCode: "+91",
  },
  {
    code: "RU",
    zh: "俄罗斯",
    en: "Russia",
    countryCode: "+7",
  },
  {
    code: "CA",
    zh: "加拿大",
    en: "Canada",
    countryCode: "+1",
  },
  {
    code: "BR",
    zh: "巴西",
    en: "Brazil",
    countryCode: "+55",
  },
  {
    code: "AE",
    zh: "阿联酋",
    en: "United Arab Emirates",
    countryCode: "+971",
  },
  {
    code: "SA",
    zh: "沙特阿拉伯",
    en: "Saudi Arabia",
    countryCode: "+966",
  },
  {
    code: "TR",
    zh: "土耳其",
    en: "Turkey",
    countryCode: "+90",
  },
  {
    code: "ZA",
    zh: "南非",
    en: "South Africa",
    countryCode: "+27",
  },
  {
    code: "EG",
    zh: "埃及",
    en: "Egypt",
    countryCode: "+20",
  },
  {
    code: "CH",
    zh: "瑞士",
    en: "Switzerland",
    countryCode: "+41",
  },
  {
    code: "SE",
    zh: "瑞典",
    en: "Sweden",
    countryCode: "+46",
  },
  {
    code: "NL",
    zh: "荷兰",
    en: "Netherlands",
    countryCode: "+31",
  },
  {
    code: "BE",
    zh: "比利时",
    en: "Belgium",
    countryCode: "+32",
  },
  {
    code: "NO",
    zh: "挪威",
    en: "Norway",
    countryCode: "+47",
  },
  {
    code: "DK",
    zh: "丹麦",
    en: "Denmark",
    countryCode: "+45",
  },
  {
    code: "FI",
    zh: "芬兰",
    en: "Finland",
    countryCode: "+358",
  },
  {
    code: "IE",
    zh: "爱尔兰",
    en: "Ireland",
    countryCode: "+353",
  },
  {
    code: "PT",
    zh: "葡萄牙",
    en: "Portugal",
    countryCode: "+351",
  },
  {
    code: "GR",
    zh: "希腊",
    en: "Greece",
    countryCode: "+30",
  },
  {
    code: "IL",
    zh: "以色列",
    en: "Israel",
    countryCode: "+972",
  },
];
